import { Column, Entity } from 'typeorm';
import { CommonColumns } from '../../../../common-columns.entity';

@Entity('dl_master')
export class DLMasterEntity extends CommonColumns {

    @Column('varchar', { name: "item_name", length: 255, nullable: true })
    itemName: string;

    @Column('varchar', { name: "season", length: 255, nullable: true })
    season: string;

    @Column('varchar', { name: "helper", length: 255, nullable: true })
    helper: string;

    @Column('varchar', { name: "main_sample_code2", length: 255, nullable: true })
    mainSampleCode2: string;

    @Column('varchar', { name: "production_plan_type_name", length: 15, nullable: true })
    productionPlanTypeName: string;

    @Column('varchar', { name: "fabric_lead_time", nullable: true })
    fabricLeadTime: number;

    @Column('varchar', { name: "trim_lead_time", nullable: true })
    trimLeadTime: number;

    @Column('varchar', { name: "po_lead_time", nullable: true })
    poLeadTime: number;

    @Column('varchar', { name: "sam", nullable: true })
    sam: number;

    @Column('varchar', { name: "keisu", nullable: true })
    keisu: number;

    @Column('varchar', { name: "body", nullable: true })
    body: number;

    @Column({ name: "sleeve", length: 255, nullable: true })
    sleeve: string;

    @Column({ name: "rib", length: 255, nullable: true })
    rib: string;

    @Column({ name: "rib_nk_bttm", length: 255, nullable: true })
    ribNkBttm: string;

    @Column({ name: "s_j", length: 255, nullable: true })
    sJ: string;

    @Column({ name: "fleece", length: 255, nullable: true })
    fleece: string;

    @Column('varchar', { name: 'total', })
    total: number;

    @Column("uuid")
    fileReferenceId: string;
}
